import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './ListOfUnderlyings.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { format, parseISO } from 'date-fns';
import MarketFandO from "../../MarketFandO";
import { Vortex } from 'react-loader-spinner'



function ListOfUnderlyings() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {

        setloadingshow(true);

        const getUrl = BaseURL + "HighLowOpenIntrest";


        fetch(`${getUrl}/MAC/-/-/-/-/-/-/-/-`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshow(false);
                // console.log(getData, "getData")
            })
            .catch((error) => {
            });


    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);


    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/futures-and-options">F & O</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>List of underlying Securities</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='ListU-loser-sc'>
                            <div className='ListU-header'>
                                <h2><span>List Of Underlyings</span></h2>
                            </div>
                            <MarketFandO optionValue="List of underlying Securities" optionDrop="Derivative" />
                            {/* <hr className="Mosthr"></hr> */}
                            <div className='ListU-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>




                                            <th className='text-left' >Underlying</th>

                                            <th className='text-right'>No Of Contracts Traded</th>
                                            <th className='text-right'>Turnover (&#8377; in CR)</th>

                                        </tr>

                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(

                                            ({ Symbol, TradedQty, TurnOver }) => (
                                                <tr>

                                                    <td className="text-left"> {Symbol}</td>

                                                    <td className="text-right"> {(TradedQty != null) ? TradedQty.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(TurnOver != null) ? TurnOver.toFixed(2) : 0}</td>

                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default ListOfUnderlyings;